import React, { ReactElement } from 'react';
import { Route, IndexRoute } from 'react-router';
import Loadable from 'react-loadable';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { withAuthGuard } from 'ggApp/modules/router/hocs';
import { PaymentsModuleConnectedWrap } from 'ggApp/shared/screens/PaymentMethods/PaymentsModuleContext/PaymentsModuleWrap';

const Wrap = Loadable({
    loader: () => import(/* webpackChunkName: "YourTechWrap" */ './wrap'),
    loading: CircleLoader,
    delay: 300,
    timeout: 10000,
});

const EmptyState = Loadable({
    loader: () =>
        import(/* webpackChunkName: "EmptyState" */ 'ggApp/shared/screens/NewDashboard/EmptyState'),
    loading: CircleLoader,
    delay: 300,
    timeout: 10000,
});

const MixDetailScreen = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "MixDetailScreen" */ 'ggApp/shared/screens/NewDashboard/Mix/DetailScreen'
        ),
    loading: CircleLoader,
    delay: 300,
    timeout: 10000,
});

const ChangePaymentMethod = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "ChangePaymentMethod" */ 'ggApp/shared/screens/PaymentMethods/ChangePaymentMethod'
        ),
    loading: () => <CircleLoader />,
    delay: 300,
    timeout: 10000,
    render(loaded: any, props: any): React.ReactNode {
        const Component = loaded.default;
        return <PaymentsModuleConnectedWrap component={Component} {...props} />;
    },
});

const AddPaymentMethod = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "AddPaymentMethod" */ 'ggApp/shared/screens/PaymentMethods/AddNewPaymentMethod'
        ),
    loading: () => <CircleLoader />,
    delay: 300,
    timeout: 10000,
    render(loaded: any, props: any): React.ReactNode {
        const Component = loaded.default;
        return <PaymentsModuleConnectedWrap component={Component} {...props} />;
    },
});

const GuardScreen = ({ children }: { children: ReactElement }): JSX.Element => (
    <React.Fragment>{children}</React.Fragment>
);

type YourTechRouteProps = {
    yourTechMixFeatureFlag: boolean;
    mixGlobalFlag: boolean;
    termsAndConditionsFlag: boolean;
};

const YourTechRoutes = ({
    yourTechMixFeatureFlag,
    mixGlobalFlag,
}: YourTechRouteProps): JSX.Element => (
    <Route>
        <Route path="your-tech" component={withAuthGuard(GuardScreen)}>
            <Route path="add-payment-method" component={AddPaymentMethod} />
            <Route
                path=":subscriptionId/:paymentMethodType/change-payment-method"
                component={ChangePaymentMethod}
            />
            <Route
                path=":subscriptionId/:paymentMethodType/add-payment-method"
                component={AddPaymentMethod}
            />
        </Route>

        {mixGlobalFlag && yourTechMixFeatureFlag && (
            <Route path="your-mix" component={withAuthGuard(GuardScreen)}>
                <Route component={Wrap}>
                    <IndexRoute component={EmptyState} />

                    <Route path="mix-device">
                        <IndexRoute component={EmptyState} />
                        <Route path=":mixDeviceId" component={MixDetailScreen} />
                    </Route>
                </Route>
            </Route>
        )}
    </Route>
);

export default YourTechRoutes;
